/** What the card at the bottom of the play screen shows. */
export type Face = "court" | "menu" | "setup" | "share";

/** Setup and sharing fill the card with their own darker look and take the
 * play controls' place. */
export const isPanel = (face: Face) => face === "setup" || face === "share";
